import { ContractBalancesViewModel } from '@models/Contract';
import { OptionsViewModel } from '@models/common.models';

export interface ACHPaymentViewModel {
  accountNumber?: string;
  routingNumber?: string;
}

export interface CreditCardPaymentViewModel {
  expirationMonth?: number;
  expirationYear?: number;
  nameOnCard?: string;
  number?: string;
  securityCode?: string;
  token?: string;
  creditCardType?: string;
}

export interface CreditCardChargeViewModel {
  chargeId: number;
  chargeAmount: number;
  chargeDate?: Date;
  calculatedAmount: number;
}

export interface ContractPaymentDetailViewModel {
  contractId: number;
  maxTerm: number;
  paymentBalance: number;
  propertySaleTypeCategoryId: number;
  enableDemandLetter: boolean;
  isRenewal: boolean;
  creditCardPayment: CreditCardPaymentViewModel;
  creditCardCharges: Array<CreditCardChargeViewModel>;
}

export interface DemandLetterPaymentViewModel {
  contractBillTo: number;
}
export enum PaymentTerms {
  OneInstallment = 1,
  TwoInstallments = 2,
  ThreeInstallments = 3,
  SixInstallments = 6,
  TwelveInstallments = 12
}

export enum PaymentType {
  ACH,
  CreditCard,
  DemandLetter,
  Check,
  None
}

export enum PaymentPurpose {
  Contract,
  SWO,
  PreAuthorization,
  Multiple
}

export interface PaymentViewModel {
  paymentACHBalance?: ACHPaymentViewModel;
  paymentACHInitial?: ACHPaymentViewModel;
  paymentAmountInitial?: number;
  paymentCreditCardBalance?: CreditCardPaymentViewModel;
  paymentCreditCardInitial?: CreditCardPaymentViewModel;
  paymentDemandLetterBalance?: DemandLetterPaymentViewModel;
  paymentDemandLetterInitial?: DemandLetterPaymentViewModel;
  paymentDate?: Date;
  paymentTerms: PaymentTerms;
  paymentTypeBalance: PaymentType;
  paymentTypeInitial: PaymentType;
}

export interface ContractCheckPaymentViewModel {
  contractId: number;
  checkDate: Date;
  checkNumber: string;
  balances: Array<ContractBalancesViewModel>;
  paymentSource?: OptionsViewModel;
}



// WEBPACK FOOTER //
// ./src/_models/Payment.ts